import React from 'react';
import { BrowserRouter as Router, Route, HashRouter } from 'react-router-dom';
import { AnimatedSwitch } from 'react-router-transition';

import './App.css';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import LandingPage from './components/LandingPage';
import AboutPage from './components/AboutPage';
import GamesPage from './components/GamesPage';
import ContactPage from './components/ContactPage';

class App extends React.Component
{
	state = {

		gameList: [
			{
				gameName: "Petered Out",
				gameLink: "https://gamejolt.com/games/PeteredOut/337563",
				gameThumbnailURL: "peteredout.png",
				gameBannerURL: "peteredout.png",
				gameVideoURL: "https://www.youtube.com/embed/69KyfzTFv-w",
				gameDescription:
					"This our college group's undergraduate thesis.\n\n" +
					"We get a glimpse at the life of fairly you child, Peter, who has developed Post-Traumatic Stress Disorder (PTSD). " +
					"Through different POVs, we learn about the symptoms and the proper way of approaching someone with the disorder.\n\n" +
					"NOTE: This game does not serve as a substitute for a professional. " +
					"If you are experiencing PTSD or know someone with the disorder, please contact a professional for help.\n\n" +
					"Contribution/s:\n" +
					"- Programming\n" +
					"- Game Design\n\n" +
					"Award/s:\n" +
					"- People's Choice Award (Ateneo Interlinks Event)",
				gamePath: "petered",
				gameScreenshots: [
					"SS1.png",
					"SS2.png",
					"SS3.png",
					"SS4.png",
					"SS5.png",
					"SS6.png",
				]
			},
			{
				gameName: "Global Game Job",
				gameLink: "https://gamejolt.com/games/GlobalGameJob/315389",
				gameThumbnailURL: "ggj2018.png",
				gameBannerURL: "ggj2018.png",
				gameVideoURL: "https://www.youtube.com/embed/SMyqlsA5IwA",
				gameDescription:
					"My group of friends' entry for Global Game Jam 2018.\n\n" +
					"You play as an I.T. Professional of a game jam who has to manage the limited bandwidth of internet across three teams. " +
					"Make sure not to neglect any team over the others or they just might straight up cost you the game.\n\n" +
					"Contribution/s:\n" + 
					"- Programming\n" + 
					"- Game Design\n\n" + 
					"Award/s:\n " + 
					"- Top 5 Games (FEU Game Jam Site)\n" + 
					"- Judges' Choice (FEU Game Jam Site)",
				gamePath: "ggj2018",
				gameScreenshots: [
					"SS1.png",
					"SS2.png",
					"SS3.png",
				]
			},
			{
				gameName: "The Familiar",
				gameLink: "https://globalgamejam.org/2019/games/familiar-0",
				gameThumbnailURL: "ggj2019.png",
				gameBannerURL: "ggj2019.png",
				gameVideoURL: "https://www.youtube.com/embed/7hoRJamEgd8",
				gameDescription:
					"My group of friends' entry for Global Game Jam 2019.\n\n" +
					"A teenager finds himself waking up to an eerie and unfamiliar house " +
					"which he explores as he tries to recollect his memories and remember what home truly meant to him.\n\n" +
					"Contribution/s:\n" +
					"- Programming\n" +
					"- Game Design\n\n",
				gamePath: "ggj2019",
				gameScreenshots: [
					"SS1.png",
					"SS2.png",
					"SS3.png",
					"SS4.png",
					"SS5.png",
				]
			},
			{
				gameName: "Disclaimer: Don't Tell My Parents",
				gameLink: "https://gamejolt.com/games/disclaimerdtmp/246215",
				gameThumbnailURL: "disclaimer.png",
				gameBannerURL: "disclaimer.png",
				gameVideoURL: "https://www.youtube.com/embed/-iCyh7OV6rc",
				gameDescription:
					"My first freelance gig as a college student.\n\n" + 
					"You follow the life of a lonely person. " +
					"Your encounters and choices will determine whether you will " +
					"make or break the only emotional lifelines you have left.\n\n" + 
					"Contribution/s:\n" + 
					"- Programming" + 
					"- 3D Models",
				gamePath: "disclaimer",
				gameScreenshots: [
					"SS1.png",
					"SS2.png",
					"SS3.png",
					"SS4.png",
				]
			},
			{
				gameName: "Literally Ball",
				gameLink: "https://gamejolt.com/games/LiterallyBall/293471",
				gameThumbnailURL: "ballgame.png",
				gameBannerURL: "literallyball.png",
				gameVideoURL: "https://www.youtube.com/embed/3TV8FuXE_vQ",
				gameDescription:
					"A small side project of mine.\n\n" +
					"It's a simple platformer with hazards, enemies, an end goal, and a moving animation with more than 4 frames. " +
					"It currently has only one level and development has been postponed indefinitely due to lack of level design and art skills at the time.\n\n" +
					"Contribution/s:\n" +
					"- Programming\n" +
					"- Art",
				gamePath: "literally_ball",
				gameScreenshots: [
					"SS1.png",
					"SS2.png",
					"SS3.png",
				]
			},
			{
				gameName: "Totally Not Captain America",
				gameLink: "https://gamejolt.com/games/NotSteveRogers/286914",
				gameThumbnailURL: "notcaptam.png",
				gameBannerURL: "captain.png",
				gameVideoURL: "https://www.youtube.com/embed/pAY_iiL_l4I",
				gameDescription:
					"A quick game I made in college for a presentation on what kind of development I do.\n\n" +
					"You go through the halls of the infamous group 'Hyrdo'. " +
					"You fight your way through waves of henchmen and lasers " +
					"as you prepare for the final boss fight with 'Rad Skull'.\n\n" +
					"Contribution/s:\n" +
					"- Programming\n" +
					"- Art\n" + 
					"- Game Design",
				gamePath: "captain",
				gameScreenshots: [
					"SS1.png",
					"SS2.png",
					"SS3.png",
					"SS4.png",
				]
			},
			{
				gameName: "Sushi Game",
				gameLink: "https://gamejolt.com/games/sushi-game-about-sushi/142532",
				gameThumbnailURL: "sushi.png",
				gameBannerURL: "sushigame.png",
				gameVideoURL: "https://www.youtube.com/embed/N-zDfoUWF7Q",
				gameDescription:
					"My first ever personal project.\n\n" +
					"I asked three of my blockmates to give me a category, an item, and a game mechanic. " +
					"Their answers were 'FOOD', 'SUSHI', and 'FALLING', thus the birth of this game where you " +
					"play as sushi trying to avoid the falling chopsticks trying to eat you.\n\n" +
					"Contribution/s:\n" +
					"- Programming\n" +
					"- Art\n" + 
					"- Game Design\n\n" +
					"Award/s:\n " +
					"- Worst Name For A Game Award (Me)",
				gamePath: "sushi",
				gameScreenshots: [
					"SS1.png",
					"SS2.png",
					"SS3.png",
					"SS4.png",
					"SS5.png",
				]
			}
		]

	};
	
	render()
	{
		return (

			<HashRouter>

				<Route exact path="/">

					<Navbar />
					<LandingPage
						gameList={this.state.gameList}
					/>
					<Footer />

				</Route>

				<Route path="/portfolio/about">

					<Navbar />
					<AboutPage />
					<Footer />

				</Route>

				<Route path="/portfolio/games">

					<Navbar />
					<GamesPage
						gameList={this.state.gameList}
					/>
					<Footer />

				</Route>

				<Route path="/portfolio/contact">

					<Navbar />
					<ContactPage />
					<Footer />

				</Route>

			</HashRouter>
		);
	}
}

export default App;
